export const arrowUpRightSvg = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Arrow Up Right</title>
    <path
      d="M2.44196 2.25H8.93304L1 10.183L1.88388 11.0669L9.81695 3.13386V9.625H11.067V1H2.44196V2.25Z"
      className="fill-ock-foreground"
    />
  </svg>
);
